import type { FunctionComponent } from 'react'

import type { ClientInputs } from '../../../types'
import type { FlowChoice, PairingChoice } from './ParingChoiceSelector'

import { AloneSameDeviceStart } from './AloneSameDeviceStart'
import { CoupleSameDeviceStart } from './CoupleSameDeviceStart'
import { CoupleSeparateDeviceStart } from './CoupleSeparateDeviceStart'

export const StartFlow: FunctionComponent<{
	flowChoice: FlowChoice | null
	pairingChoice: PairingChoice | null
	clientInputs?: ClientInputs
	children?: never
}> = ({ flowChoice, pairingChoice, clientInputs }) => {
	if (pairingChoice == null) {
		return null
	}
	if (pairingChoice === 'alone') {
		return <AloneSameDeviceStart clientInputs={clientInputs} />
	}
	switch (flowChoice) {
		case 'sameDevice':
			return <CoupleSameDeviceStart clientInputs={clientInputs} />
		case 'differentDevices':
			return <CoupleSeparateDeviceStart clientInputs={clientInputs} />
		default:
			return null
	}
}
